export const COLORS = {
  primary: '#00FFB9',
} as const;

// Call Volume Chart Colors
export const CALL_VOLUME_COLORS = {
  INBOUND: {
    light: '#23407A',
    dark: '#1681F6'
  },
  OUTBOUND: {
    light: '#00FEC1',
    dark: '#00FEC1'
  },
  INBOUND_DIRECT: {
    light: '#FFB300',
    dark: '#FFB300'
  },
  INTERNAL: {
    light: '#8E44AD',
    dark: '#8E44AD'
  }
} as const;

export const LINE_CHART_COLORS = {
  LINE: {
    light: '#23407A',
    dark: '#1681F6'
  },
  DOT_FILL: {
    light: 'white',
    dark: '#0f172a'
  },
  TOOLTIP_TEXT: {
    light: '#1e3a8a', // blue-900
    dark: '#60a5fa'  // blue-400
  }
} as const;

/** Palette dùng chung cho donut/pie chart (Call Quality Distribution, Calls Handled By Queue, ...) */
export const CHART_BASE_COLORS = [
  '#00FEC1', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D', '#FF6B6B', '#4ECDC4',
  '#FF9F1C', '#2EC4B6', '#E71D36', '#011627', '#7B2CBF', '#3A0CA3', '#4361EE', '#4CC9F0',
  '#F72585', '#7209B7', '#3A0CA3', '#4361EE', '#4CC9F0', '#4895EF', '#560BAD', '#480CA8',
  '#3F37C9', '#4CC9F0', '#F72585', '#B5179E', '#7209B7', '#3A0CA3', '#4361EE', '#4895EF',
] as const;

export const CHART_PALETTE_LIGHT = ['#23407a', ...CHART_BASE_COLORS];
export const CHART_PALETTE_DARK = ['#1681F6', ...CHART_BASE_COLORS]; 